import React from "react";
import "./uiPending.scss";

export interface TabItem<T extends string> {
  id: T;
  label: React.ReactNode;
}

interface TabsProps<T extends string> {
  tabs: TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
  "aria-label": string;
}

/** Pending src/ui component: underlined page-level tabs (role=tablist). */
function Tabs<T extends string>({ tabs, active, onChange, ...rest }: TabsProps<T>) {
  return (
    <div className="sa-tabs" role="tablist" aria-label={rest["aria-label"]}>
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={t.id === active}
          className={`sa-tabs__tab${t.id === active ? " sa-tabs__tab--active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
